import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

// components
import Navbar from "components/Navbars/AuthNavbar.js";
import FooterSmall from "components/Footers/FooterSmall.js";

// views
import Login from "views/auth/Login";
import RequestResetPassword from "views/auth/RequestResetPassword";
import ResetPasswordFinish from "views/auth/ResetPasswordFinish";

export default function Auth() {
  return (
    <>
      <Navbar transparent />
      <main>
        <section className="relative w-full h-full py-40 min-h-screen">
          <div className="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-full"></div>
          <Switch>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/auth/reset-password/init" exact component={RequestResetPassword} />
            
            {/* Route sous le préfixe /auth/ */}
            <Route path="/auth/reset/finish" component={ResetPasswordFinish} />
            <Route path="/auth/reset-password/finish" component={ResetPasswordFinish} />

            {/* Redirection fallback en cas de route inconnue sous /auth */}
            <Redirect from="/auth" to="/auth/login" />
          </Switch>
          <FooterSmall absolute />
        </section>
      </main>
    </>
  );
}